import { render, staticRenderFns } from "./DirectionVerticalIcon.vue?vue&type=template&id=56a6c476&"
import script from "./DirectionVerticalIcon.vue?vue&type=script&lang=js&"
export * from "./DirectionVerticalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports